import React from 'react';
import { Input, Price } from 'components';
import { Field } from 'formik';
import PropTypes from 'prop-types';
import { t } from 'ttag';

function Number({ numberOptions, hidePrice }) {
  if (numberOptions && numberOptions.isVisible)
    return (
      <div>
        <div className="mb-2 flex items-center justify-between">
          <span className="text-xs font-bold uppercase">{t`Add Player number`}</span>
          {!hidePrice && numberOptions.price && (
            <Price
              unitPrice={numberOptions.price}
              priceSize="xs"
              priceFontWeight="semibold"
            />
          )}
        </div>
        <Field name={numberOptions.name}>
          {({ field, meta }) => (
            <Input
              {...field}
              value={field.value || ''}
              id={numberOptions.name}
              label={numberOptions.placeholder}
              type="text"
              isInvalid={meta.touched && !!meta.error}
              errorMessage={meta.error}
              isValid={meta.touched && !meta.error}
              helperMessage={`${t`Max Length`}: ${
                field.value ? field.value.toString().length : 0
              }/${numberOptions.max_length}`}
              autoComplete="off"
              maxLength={2}
              pattern="[0-9]*"
              inputMode="numeric"
            />
          )}
        </Field>
      </div>
    );
  return null;
}

Number.propTypes = {
  numberOptions: PropTypes.shape({
    price: PropTypes.string,
    customization_image: PropTypes.string,
    name: PropTypes.string,
    placeholder: PropTypes.string,
    title: PropTypes.string,
    type: PropTypes.string,
    id: PropTypes.number,
    max_length: PropTypes.number,
    isVisible: PropTypes.bool
  }),
  hidePrice: PropTypes.bool
};

Number.defaultProps = {
  numberOptions: undefined,
  hidePrice: false
};

export default Number;
